import React from "react";
import { connect } from "react-redux";
import { modelsFromObject } from "../helpers/models-from-object.js";
import { addBot } from "./connection/firebase-rooms.js";
import MenuHeader from "../b5-home/MenuHeader.js";
import InviteModal from "../b5-home/FullteamInviteModal.js"; //TODO: rename this file?
import { setMatchmakingValue } from "../redux-actions/battle-actions.js";
import RallyCombatantsList from "./RallyCombatantsList";
import LobbyCTA from "../b5-home/LobbyCTA.js";
import { sendReadyToFirebase } from "./connection/firebase-send-ready.js";
import AudioControl from '../_audio/AudioControl'
import audioManager from '../_audio/audio-manager'


class RallyBattleLobby extends React.Component {

  componentDidMount() {
    //Play the music!
    audioManager.playSong("music_b5Menu");
  }

  handleCloseInviteLinkModal() {
    setMatchmakingValue({
      isLobbyInviteModalOpen: false
    });
  }

  /* Disable the button if there are too many combatants */
  isBotButtonDisabled() {
    return (
      this.props.initialCombatantData &&
      Object.keys(this.props.initialCombatantData).length >= 6
    );
  }

  handleAddBotButtonClick() {
    addBot();
  }

  handleStartButtonClick() {
    sendReadyToFirebase(() => {
      //console.log('ready!')
      //TODO: if you want to fancy up the interaction, you have this callback.
    });
  }

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "45em",
      margin: "0 auto"
    };
  }

  renderInviteLinkModal() {
    if (this.props.isLobbyInviteModalOpen) {
      return (
        <InviteModal
          handleCloseCallback={this.handleCloseInviteLinkModal.bind(this)}
        />
      );
    }
    return null;
  }

  renderReadyButton() {
    const isReady = this.props.roomReadyClients[this.props.logggedInUserId];
    const isStartDisabled =
      modelsFromObject(this.props.initialCombatantData).length < 2;

    if (isStartDisabled) {
      return (
        <LobbyCTA
          text="Need an opponent"
          isPrimary={false}
          isDisabled={true}
          isDisabledAppearance={true}
        />
      );
    }

    if (isReady) {
      return (
        <LobbyCTA
          text="Ready!"
          isDisabled={true}
          isReadyPressed={true}
          handler={function() {}}
        />
      );
    }
    return (
      <LobbyCTA
        text="Ready to Battle"
        isPrimary={true}
        isDisabled={false}
        handler={this.handleStartButtonClick.bind(this)}
      />
    );
  }

  renderBotButton() {
    if (this.props.isMultiplayerMasterClient) {

      const isDisabled = this.isBotButtonDisabled();

      return (
        <LobbyCTA
          text={!isDisabled ? "Add Bot" : "Battle is full!"}
          isDisabled={isDisabled}
          isDisabledAppearance={isDisabled}
          handler={this.handleAddBotButtonClick.bind(this)}
        />
      );
    }
    return null;
  }

  renderBottomUi() {
    return (
      <div>
        {this.renderReadyButton()}
        {this.renderBotButton()}
      </div>
    );
  }

  render() {
    if (!this.props.initialCombatantData) {
      console.warn(
        "this.props.initialCombatantData is undefined in RallyBattleLobby. Shouldnt be mounted"
      );
      return <div>No Combatant Data</div>; //TODO: ERROR STATE?
    }
    const combatantsList = modelsFromObject(
      this.props.initialCombatantData || {}
    );

    const { viewportMode } = this.props;

    const style = {
      fontSize: viewportMode === "portrait" ? "0.6em" : "0.45em", //mobile, desktop
      height: "100%",
      paddingTop: "4em"
    };

    return (
      <div style={{ height: "100%" }}>
        <div style={style} className="page-container menu-texture">
          {/*Top, header container*/}
          {/*<div className="page-container--section">*/}
            <MenuHeader />
            <AudioControl />
          {/*</div>*/}

          <div
            className="page-container--section"
            style={this.getDesktopWrap()}
          >
            <RallyCombatantsList combatantsList={combatantsList} isMaster={this.props.isMultiplayerMasterClient} />
          </div>

          <div
            className="page-container--section"
            style={{ padding: "2em 2em 3em", ...this.getDesktopWrap() }}
          >
            {this.renderBottomUi()}
          </div>
        </div>

        {this.renderInviteLinkModal()}
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,
    currentRoomId: state.matchmaking.currentRoomId,
    initialCombatantData: state.matchmaking.initialCombatantData,

    //serverRoomConnections: state.battle.serverRoomConnections,
    isMultiplayerMasterClient: state.battle.isMultiplayerMasterClient,

    //invite modal
    isLobbyInviteModalOpen: state.matchmaking.isLobbyInviteModalOpen,

    //readyness
    roomReadyClients: state.matchmaking.readyClients, //know who's ready in the room
    logggedInUserId: state.crew.logggedInUserId
  };
})(RallyBattleLobby);



// WEBPACK FOOTER //
// ./src/battle/RallyBattleLobby.js